/*
 * @Author: Tina Huang
 * @Date: 2024-03-04 12:40:48
 * @LastEditors: HTT httishere0728@gmail.com
 * @LastEditTime: 2025-08-31 00:11:36
 * @Description:
 */
import { Tag } from 'antd'
import styles from './index.module.css'
export default function NewItem(props: { item: any }) {
  const { item } = props
  const types: any = {
    update: {
      label: '迭代更新',
      style: 'green',
    },
    others: {
      label: 'QA',
      style: 'red',
    },
    top: {
      label: '置顶',
      style: 'magenta',
    },
  }
  return (
    <div className={`m-auto bg-white rounded-md mb-4 p-5 shadow-2xl ${styles.noticeItem} new-notify`}>
      <Tag className='notify-tag' color={types[item?.type]?.style}>{types[item?.type]?.label}</Tag>
      <h1 className="text-center text-2xl font-bold mb-2 mt-1">{item?.title}</h1>
      <div dangerouslySetInnerHTML={{ __html: item?.msg }} className="mt-2"></div>
      <p className="mt-4 text-right">{item?.datetime}</p>
    </div>
  )
}
